import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class WidgetsService {
    private _scrollStarted$ = new BehaviorSubject<boolean>(false);
    public readonly scrollStarted$: Observable<boolean> = this._scrollStarted$.asObservable();

    notifyScrollStarted(): void {
        this._scrollStarted$.next(true);
    }
    resetScrollEvent(): void {
        this._scrollStarted$.next(false);
    }
}
